import { createContext } from 'react';

const listaGrupoContext = createContext();

export default listaGrupoContext;
